/**
 * Preloads an image and invokes onLoaded once it is loaded and decoded (ready to paint).
 * Uses Image.decode() so the callback runs when the image can be displayed without jank.
 */
export function preloadImage(src: string, onLoaded: () => void) {
  const image = new Image();

  image.addEventListener('load', () => {
    image.decode().then(onLoaded).catch(onLoaded);
  });

  image.addEventListener('error', onLoaded);

  image.src = src;
}
